export default "__VITE_ASSET__D4yx$iX6__"